import { Directive, HostListener } from '@angular/core';

/**
 * @deprecated Usar directiva DebounceClickDirective, esta directiva puede presentar problemas
 * si se usa en conjunto con el atributo disabled de un botón
 */
@Directive({
  selector: '[appNoDblClick]'
})
export class NoDblClickDirective {

  constructor() { }

  @HostListener('click', ['$event'])

  /*
    clickEvent(event) {
      event.srcElement.setAttribute('disabled', true);
      setTimeout(function(){
        event.srcElement.removeAttribute('disabled');
      }, 1000);
    }*/

  clickEvent(event) {
    // see if the srcElement has the disabled property.
    // If so then it is the actual button. If not then the user
    // clicked on the button's text (span element)
    const button = (event.target.disabled === undefined) ? event.target.parentElement : event.target;
    button.setAttribute('disabled', true);
    setTimeout(function () {
      button.removeAttribute('disabled');
    }, 1000);
  }

}

// https://gist.github.com/svetlio/8997fe4591c38095f57e17a759b31720